import {
  FRENCH_PHONE_INVALID_MESSAGE,
  FRENCH_PHONE_REGEX,
  isOptionalFrenchPhoneValid,
  normalizeFrenchPhoneCandidate,
} from "@/lib/cat/french-phone";
import {
  EMAIL_OR_PHONE_REQUIRED_MESSAGE,
  INVALID_EMAIL_MESSAGE,
  INVALID_FIRST_NAME_MESSAGE,
  INVALID_LAST_NAME_MESSAGE,
  INVALID_POSTAL_CODE_MESSAGE,
  isValidEmail,
  isValidLastName,
  isValidOptionalFirstName,
  isValidPostalCode,
  POSTAL_CODE_REGEX,
  REQUIRED_FIELD_MESSAGE,
  SEARCH_NAME_REGEX,
} from "@/lib/cat/party-profile-validation";

const SEARCH_EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const SEARCH_FRENCH_PHONE_REGEX = FRENCH_PHONE_REGEX;

export {
  EMAIL_OR_PHONE_REQUIRED_MESSAGE,
  FRENCH_PHONE_INVALID_MESSAGE,
  INVALID_EMAIL_MESSAGE,
  INVALID_FIRST_NAME_MESSAGE,
  INVALID_LAST_NAME_MESSAGE,
  INVALID_POSTAL_CODE_MESSAGE,
  isOptionalFrenchPhoneValid,
  isValidEmail,
  isValidLastName,
  isValidOptionalFirstName,
  isValidPostalCode,
  normalizeFrenchPhoneCandidate,
  POSTAL_CODE_REGEX,
  REQUIRED_FIELD_MESSAGE,
  SEARCH_EMAIL_REGEX,
  SEARCH_FRENCH_PHONE_REGEX,
  SEARCH_NAME_REGEX,
};
